(function () {
  /* ---------- Helpers ---------- */
  function getCookie(name) {
    var cname = name + '=';
    var decoded = decodeURIComponent(document.cookie);
    var parts = decoded.split(';');
    for (var i = 0; i < parts.length; i++) {
      var c = parts[i];
      while (c.charAt(0) === ' ') c = c.substring(1);
      if (c.indexOf(cname) === 0) return c.substring(cname.length, c.length);
    }
    return '';
  }

  /* ---------- Tabs ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-tab-btn]');
    if (!btn) return;
    var wrapper = btn.closest('[data-cart-tabs]');
    if (!wrapper) return;
    var target = btn.dataset.cartTabBtn;

    wrapper.querySelectorAll('[data-cart-tab-btn]').forEach(function (b) {
      b.classList.toggle('active', b === btn);
    });
    wrapper.querySelectorAll('[data-cart-tab-panel]').forEach(function (panel) {
      panel.classList.toggle('hidden', panel.dataset.cartTabPanel !== target);
    });
  });

  /* ---------- "For You" recommendations (Shopify recommendation engine) ---------- */
  if (!customElements.get('cart-recommendations')) {
    class CartRecommendations extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.url) return; // this is the fetched/replaced instance, skip

        if (!('IntersectionObserver' in window)) {
          this.fetchRecommendations();
          return;
        }
        var observer = new IntersectionObserver(
          (entries, obs) => {
            if (entries[0].isIntersecting) {
              obs.unobserve(this);
              this.fetchRecommendations();
            }
          },
          { rootMargin: '0px 0px 200px 0px' }
        );
        observer.observe(this);
      }

      fetchRecommendations() {
        fetch(this.dataset.url)
          .then((res) => res.text())
          .then((text) => {
            var wrapper = document.createElement('div');
            wrapper.innerHTML = text;
            var source = wrapper.querySelector('cart-recommendations');
            if (source && source.innerHTML.trim().length) {
              this.removeAttribute('data-url');
              this.innerHTML = source.innerHTML;
            } else {
              this.closest('[data-cart-tab-panel]') && (this.closest('[data-cart-tab-panel]').innerHTML = '');
            }
          })
          .catch(() => {});
      }
    }
    customElements.define('cart-recommendations', CartRecommendations);
  }

  /* ---------- "Recently Viewed" (reads the theme's existing tracking cookie) ---------- */
  if (!customElements.get('cart-recently-viewed')) {
    class CartRecentlyViewed extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded) return;
        this.dataset.loaded = 'true';
        this.load();
      }

      load() {
        var raw = getCookie('sf-recent-viewed-products');
        if (!raw) return;
        var handles;
        try {
          handles = Array.from(new Set(JSON.parse(raw)));
        } catch (e) {
          return;
        }
        var currentHandle = this.dataset.currentHandle;
        if (currentHandle) {
          handles = handles.filter(function (h) {
            return h !== currentHandle;
          });
        }
        handles = handles.slice(0, 6);
        if (!handles.length) return;

        var grid = document.createElement('div');
        grid.className = 'cart-recs__grid';
        this.appendChild(grid);

        handles.forEach((handle) => {
          fetch('/products/' + handle + '?view=cart-recent-card')
            .then((res) => res.text())
            .then((html) => {
              var wrap = document.createElement('div');
              wrap.innerHTML = html;
              var card = wrap.querySelector('[data-view="card"]');
              if (!card) return;
              var item = document.createElement('div');
              item.className = 'cart-recs__item';
              item.appendChild(card);
              grid.appendChild(item);
            })
            .catch(() => {});
        });
      }
    }
    customElements.define('cart-recently-viewed', CartRecentlyViewed);
  }
})();